interface GoogleTagManagerProps {
  gtmId: string;
}

// Split into two components because they belong in different documents' regions.
// The inline snippet is the standard GTM pattern and stays SSR'd in <head>; the
// <noscript><iframe> must not. An <iframe> inside <head> makes the HTML parser
// bail out of "in head" insertion mode and implicitly open <body> early, which
// moves everything after it — so GtmNoScript renders as the first child of <body>
// instead. See app/root.tsx's Layout.
export function GtmHeadScript({ gtmId }: GoogleTagManagerProps) {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `(function(w,d,s,l,i){if(d.documentElement.hasAttribute('data-hide-chrome'))return;w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`,
      }}
    />
  );
}

export function GtmNoScript({ gtmId }: GoogleTagManagerProps) {
  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
        title="Google Tag Manager"
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
      />
    </noscript>
  );
}
